import PropTypes from 'prop-types';
import classes from './head.module.css';

const Head = (props) => {
  const {
    title,
    subtitle,
  } = props;

  return (
    <div className={classes.head}>
      <div className={classes.title}>{title}</div>
      <div className={classes.subtitle}>{subtitle}</div>
    </div>
  );
};

Head.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Head;
